import { isAuthorizationError, useTenant } from "@how/app-kit";
import { Card, SimpleGrid, Stack, Text, Title } from "@mantine/core";
import { ErrorState, LoadingState, PageHeader, PermissionDenied, StatusBadge } from "@how/ui";
import { env } from "../../lib/env";
import { useOwnProfile, useTenantRecord } from "../tenant/queries";
import { ChurchTimeZone } from "./ChurchTimeZone";

export function HomePage() {
  const tenant = useTenant();
  const record = useTenantRecord();
  const profile = useOwnProfile();
  const name = record.data?.name ?? (tenant.status === "resolved" ? tenant.tenant.slug : "");
  // On the staff door the church's address is the door with the church in the path, not its old dashboard host.
  const servedOn =
    tenant.status !== "resolved"
      ? "unresolved"
      : tenant.tenant.basePath === ""
        ? tenant.tenant.hostname
        : `dash.${env.VITE_HOW_PLATFORM_BASE_DOMAIN}${tenant.tenant.basePath}/`;
  return (
    <>
      <PageHeader
        title={profile.data?.display_name ? `Welcome, ${profile.data.display_name}` : "Welcome"}
        description="Your church's staff dashboard. Everything your team needs, in one place."
      />
      <SimpleGrid cols={{ base: 1, md: 2 }}>
        <Card>
          {record.isPending ? (
            <LoadingState rows={3} />
          ) : record.isError ? (
            isAuthorizationError(record.error) ? (
              <PermissionDenied />
            ) : (
              <ErrorState
                message="Could not load your church."
                onRetry={() => {
                  void record.refetch();
                }}
              />
            )
          ) : (
            <Stack gap="xs">
              <Title order={4}>{name}</Title>
              <Text size="sm" c="dimmed">
                {record.data.slug} · {record.data.locale}
              </Text>
              <StatusBadge domain="tenant_status" value={record.data.status} />
              <ChurchTimeZone zone={record.data.time_zone} />
            </Stack>
          )}
        </Card>
        <Card>
          <Stack gap="xs">
            <Title order={4}>Served on</Title>
            <Text size="sm" c="dimmed">
              {servedOn}
            </Text>
          </Stack>
        </Card>
      </SimpleGrid>
    </>
  );
}
